export default __webpack_public_path__ + "static/media/search-1.4bd2f71f.png";